import React from 'react';

function Archive(){

	return <div>
		<h1>Fetching Page...</h1>
	</div>

}
export default Archive

